import {
  ListFormsSortParameterValue,
  ListTransactionsFilterParameter,
  TransactionsApiListTransactionsRequest
} from "@wingspanhq/wingspan-api-sdk";
import { UrlQuerySort } from "../../../../../shared/hooks/useUrlQuery";
import { TYPE_FILTER_ALL } from "./config";
import { TransactionsFilter, TransactionsSortField } from "./types";

export function createListTransactionsRequest(
  filter?: TransactionsFilter,
  sort?: UrlQuerySort<TransactionsSortField>
): TransactionsApiListTransactionsRequest {
  const direction =
    sort?.direction === "ascending"
      ? ListFormsSortParameterValue.ASC
      : ListFormsSortParameterValue.DESC;

  const request: TransactionsApiListTransactionsRequest = {
    sort: { date: direction }
  };

  const filterParam: ListTransactionsFilterParameter = {};

  if (filter?.type && filter.type !== TYPE_FILTER_ALL) {
    filterParam.type = { eq: filter.type };
  }

  if (filter?.category) {
    filterParam.category = { eq: filter.category };
  }

  if (Object.keys(filterParam).length > 0) {
    request.filter = filterParam;
  }

  return request;
}
